module.exports = __webpack_public_path__ + "static/media/full.926d006d.png";